export const GROUP_CHAT = `/chat/:id`
